import { useFormik } from 'formik'
import { FC } from 'react'
import { Button, FetchState, FormInput, useModal } from '../../../../../../components'
import { enviarSchema } from '../../validation/enviarSchema'
import {
  ButtonType,
  IconPaths,
  IconSize,
  KTSVG,
  MaskType,
  showError,
} from '../../../../../../../_metronic/helpers'

type IProps = {
  onConfirm: (data: { email: string; telefone: string }) => void
}

export const EnviarPrescricaoModal: FC<IProps> = ({ onConfirm }) => {
  const { closeModal, fetchStates } = useModal()

  const { data: telefone } = (fetchStates['telefone'] || {}) as FetchState<string | undefined>
  const { data: email } = (fetchStates['email'] || {}) as FetchState<string | undefined>

  const initialValues = {
    telefone: telefone || '',
    email: email || '',
  }

  const formik = useFormik({
    initialValues,
    validationSchema: enviarSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        const data = { telefone: values.telefone, email: values.email }
        onConfirm(data)
        closeModal()
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      <div className='row'>
        <div className='d-flex justify-content-center align-items-center col-md-2'>
          <KTSVG path={IconPaths.Sms} size={IconSize.ExtraLarge} />
        </div>
        <div className='col-md-8'>
          <FormInput
            formik={formik}
            label='Telefone'
            placeholder='(00) 0 0000-0000'
            mask={MaskType.Phone}
            name='telefone'
          />
          <span className='fs-8 text-muted'>
            O telefone é utilizado para o paciente baixar o PDF da receita.
          </span>
        </div>
      </div>
      <div className='row mt-2'>
        <div className='d-flex justify-content-center align-items-center col-md-2'>
          <KTSVG path={IconPaths.Email} size={IconSize.ExtraLarge} />
        </div>
        <div className='col-md-8'>
          <FormInput formik={formik} label='E-mail' placeholder='Digite o e-mail' name='email' />
        </div>
      </div>

      <div className='d-flex justify-content-end mt-4'>
        <Button type={ButtonType.Submit} className='btn-primary'>
          Enviar
        </Button>
      </div>
    </form>
  )
}
